import angular from 'angular';

class PrincipalImportCtrl {
    /*@ngInject*/
    constructor(
        $translate,
        EMAIL_REGEXP,
        User,
        PrincipalSvc,
        LadProviderService,
        KissUserSvc,
        $uibModal,
        UtilSvc,
        $state,
        PRINCIPAL,
        PrincipalPlatform
    ) {
        this.$translate = $translate;
        this.$uibModal = $uibModal;
        this.EMAIL_REGEXP = EMAIL_REGEXP;
        this.admin = new User();
        this.PrincipalSvc = PrincipalSvc;
        this.LadProviderService = LadProviderService;
        this.KissUserSvc = KissUserSvc;
        this.UtilSvc = UtilSvc;
        this.$state = $state;
        // ID de la tâche asynchrone d'import de la config
        this.taskId = null;
        this.PRINCIPAL = PRINCIPAL;
        this.PrincipalPlatform = PrincipalPlatform;
    }
    $onInit() {
        this.DOMAIN_REGEXP = /^[a-zA-Z0-9-_]*\.[a-zA-Z0-9-_]*\.[a-zA-Z]{2,}$/;
        this.includes = {
            errorMessages: require('../layouts/error-messages.html'),
        };

        this.resetImportResults = angular.copy(this.importResults);
        this.resetadmin = angular.copy(this.admin);
        this.initPrincipalData();

        this.branding = this.importResults.PRINCIPAL_BRAND;
        /* Indique si on affiche ou non la Référence du DO sur la plateforme GIS */
        this.showGisPlatformEid = this.hasGisPlatform();
        /* Indique si on affiche ou non la Référence du DO sur la plateforme PASREL */
        this.showPasrelPlatrformEid = this.hasPasrelPlatform();
        /* Indique si on affiche le bloc Ccnfiguration portail DO */
        this.showPortalConfig = this.isPortalActivate();
        this.initPrincipalDematPlatforms();
        if (this.principal.threeWayMatching) {
            this.PrincipalSvc.getWorkflowReferences(this.principal.eid).then(r => {
                this.wkfReferences = r;
            });
        }
        this.ladExternEnabled = this.isKissLadExtern();
        if (this.ladExternEnabled) {
            this.ladProviders = this.LadProviderService.findAll();
        }
        this.initPrincipalFields();
        this.showExternalLadMail = this.hasActivatedConfMailLad();
    }
    initPrincipalData() {
        this.importResults.PRINCIPAL.admin = this.admin;
        this.principal = this.importResults.PRINCIPAL.detail;
        this.principalSeller = this.importResults.PRINCIPAL.seller;
        this.principalEpdf = this.importResults.PRINCIPAL.epdf;
        this.principalBuyer = this.importResults.PRINCIPAL.buyer;
    }

    initPrincipalFields() {
        if (this.hasActivatedConfMailLad()) {
            this.principalEpdf.domainName = '';
            this.principalEpdf.pwd = '';
        }
        if (this.branding) {
            this.branding.loginUrl = '';
            this.branding.mail = '';
        }
    }

    /**
     * Permet d'initialiser les variables pour la gestion des plateformes de démat
     */
    initPrincipalDematPlatforms() {
        this.gisPlatform = new this.PrincipalPlatform();
        this.pasrelPlatform = new this.PrincipalPlatform();

        this.gisPlatform.family = 'GIS';
        this.pasrelPlatform.family = 'PASREL';

        this.pasrelPlatform.platformEid = 'PASREL';
    }
    /* Indique si le DO importé est paramétré sur la plateforme GIS*/
    hasGisPlatform() {
        return this.principal.dematPlatforms && this.principal.dematPlatforms.some(element => element.family === 'GIS');
    }
    /* Indique si le DO importé est paramétré sur la plateforme PASREL*/
    hasPasrelPlatform() {
        return (
            this.principal.dematPlatforms && this.principal.dematPlatforms.some(element => element.family === 'PASREL')
        );
    }
    /** Retourne True si le DO importé a activé la Configuration Portail Client Entreprise ou  Fournisseur Entreprise*/
    isPortalActivate() {
        return this.principal.processO2c || this.principal.processP2p;
    }
    isEmail(value) {
        // Regexp utilisé dans Angular pour valider les input[type=email]
        return this.EMAIL_REGEXP.test(value.text);
    }
    /*Indique que la LAD externe est utilisée dans KISS pour le DO*/
    isKissLadExtern() {
        return this.principalSeller && this.principalSeller.ladTypes.some(element => element === 'EXTERNAL');
    }
    /* Indique si le DO importé est paramétré avec Configuration Dépôt Mail Entreprise = 'activé'*/
    hasActivatedConfMailLad() {
        return this.principalEpdf && this.principalEpdf.mailDomainNotif;
    }

    cancel() {
        this.importResults = angular.copy(this.resetImportResults);
        this.admin = angular.copy(this.resetadmin);
        this.initPrincipalData();
        this.initPrincipalDematPlatforms();
    }
    submit() {
        this.principal.dematPlatforms.map(element => {
            element.pcpEidOnPlatform =
                element.family === 'GIS' ? this.gisPlatform.pcpEidOnPlatform : this.pasrelPlatform.pcpEidOnPlatform;
            element.platformEid =
                element.family === 'GIS' ? this.gisPlatform.platformEid : this.pasrelPlatform.platformEid;
        });

        if (this.showPortalConfig) {
            this.CheckAdminEmailAndCreatePrincipal();
        } else {
            this.checkGisAndImportConfig();
        }
    }

    /**
     * Permet de vérifier si l'utilisateur(admin) existe ou non
     *
     */
    CheckAdminEmailAndCreatePrincipal() {
        this.KissUserSvc.checkContactEmail(this.admin.email).then(
            user => {
                if (user.id === null) {
                    this.checkGisAndImportConfig();
                } else {
                    if (user.isNotAdmin() && user.isNotAccountant()) {
                        this.showAdminConfirmationModal(user);
                    } else {
                        this.$uibModal.open({
                            component: 'adminCreationErrorModal',
                            size: 'md',
                            backdrop: 'static',
                            keyboard: false,
                        });
                    }
                }
            },
            error => {
                this.logger.error('error.admin_unauthorised_domain_name_mail', error);
            }
        );
    }

    checkGisAndImportConfig() {
        if (this.hasGisPlatform()) {
            this.checkGisCompanyDetail();
        } else {
            this.startImportConfig();
        }
    }
    startImportConfig() {
        if (this.taskId) return;
        if (this.principalSeller) {
            this.importResults.PRINCIPAL.seller.mailReport = this.UtilSvc.joinMail(this.principalSeller.mailReport);
        }

        if (this.principalBuyer) {
            this.importResults.PRINCIPAL.buyer.mailReport = this.UtilSvc.joinMail(this.principalBuyer.mailReport);
        }

        this.PrincipalSvc.importConfDo(this.importResults).then(
            taskId => (this.taskId = taskId),
            () => this.logger.error('error.generic')
        );
    }

    onTaskEnd(asyncResult) {
        this.taskId = null;

        if (asyncResult.success) {
            this.result = asyncResult.result;

            this.$state.go('app.principal.consult.detail', {
                id: this.result,
            });
        } else if (asyncResult.error.message) {
            this.logger.error('error.generic', asyncResult.error.message);
        } else {
            this.logger.error('error.generic', asyncResult);
        }
    }

    /**
     * affiche le modal de confirmation d'ajout du rôle admin a l'utilisateur existant
     * @param {*} user utilisateur auquel on va ajouter le rôle admin
     */
    showAdminConfirmationModal(user) {
        this.KissUserSvc.getUser(user.login).then(userBo => {
            this.$uibModal
                .open({
                    component: 'adminCreationConfirmationModal',
                    size: 'md',
                    resolve: {
                        authorization: () => {
                            return userBo.user.legalEntityGroupUsers;
                        },
                    },
                    backdrop: 'static',
                    keyboard: false,
                })
                .result.then(
                    () => {
                        this.importResults.PRINCIPAL.admin = userBo.user;
                        this.checkGisAndImportConfig();
                    },
                    function () {}
                );
        });
    }
    mapProfilDo(dematPlatform) {
        if (dematPlatform.invoiceRe && !dematPlatform.invoiceEm) {
            return 'RECEIVER';
        } else if (!dematPlatform.invoiceRe && dematPlatform.invoiceEm) {
            return 'SENDER';
        } else {
            return 'TWO_WAY_DEMAT';
        }
    }
    /**
     * controle la cohérence des donnèes saisies avec la plateforme GIS
     */
    checkGisCompanyDetail() {
        let gisPlatform = this.principal.dematPlatforms.find(element => element.family === 'GIS');
        gisPlatform.platformEid = this.gisPlatformEid.value;
        this.PrincipalSvc.checkGisCompanyDetail(gisPlatform.platformEid, this.principal.eid).then(data => {
            if (
                data.customer !== gisPlatform.pcpEidOnPlatform ||
                data.dematDirection !== this.mapProfilDo(gisPlatform) ||
                data.label !== this.principal.corporateName
            ) {
                this.openGisControlModal(data, gisPlatform);
            } else {
                this.startImportConfig();
            }
        });
    }

    openGisControlModal(data, gisPlatform) {
        const principalProfile = this.getPrincipalProfile();
        this.$uibModal
            .open({
                component: 'controlCreateDoModal',
                size: 'md',
                resolve: {
                    modalTitle: () => {
                        return {
                            value: this.$translate.instant('principal.principal.import.gis_modal_title'),
                        };
                    },
                    modalMessage: () => {
                        return {
                            data: data,
                            principalId: this.principal.eid,
                            platformId: gisPlatform.pcpEidOnPlatform,
                            principalProfil: principalProfile,
                            principalRaison: this.principal.corporateName,
                            platformEid: gisPlatform.platformEid,
                        };
                    },
                    modalCancelButtonText: () => {
                        return { value: this.$translate.instant('principal.principal.import.gis_modal_cancel_btn') };
                    },
                    modalConfirmButtonText: () => {
                        return { value: this.$translate.instant('BTN_CONFIRM') };
                    },
                },
                backdrop: 'static',
                keyboard: false,
            })
            .result.then(
                () => this.startImportConfig(),
                () => {}
            );
    }
    getPrincipalProfile() {
        let principalProfile = '';
        if (this.principal.profilBuyer && this.principal.profilSeller) {
            principalProfile = this.PRINCIPAL.profil.buyerSeller;
        } else if (this.principal.profilSeller) {
            principalProfile = this.PRINCIPAL.profil.seller;
        } else {
            principalProfile = this.PRINCIPAL.profil.buyer;
        }
        return principalProfile;
    }
}

angular.module('app.principal').component('principalImport', {
    templateUrl: require('./principal-import.html'),
    controller: PrincipalImportCtrl,
    bindings: { importResults: '<', allDematPlatforms: '<' },
});
